module.exports = __webpack_public_path__ + "img/ka5-1.2bfb5213.png";